// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1p-2";
export var blackBorderOnHover = "_1p-7";
export var cell = "_1p-6";
export var cellContainer = "_1p-3";
export var checked = "_1p-8";
export var disabled = "_1p-5";
export var featuredIconCellContainer = "_1p-9";
export var featuredIconTextContainer = "_1p-b";
export var featuredIconWrapper = "_1p-a";
export var noBorder = "_1p-c";
export var orangeSelectedRow = "_3v-3";
export var overflowableText = "_1p-0";
export var overflowableTextContainer = "_1p-1";
export var row = "_1j-0";
export var rowCheckboxCell = "_1p-4";
export var selectableTable = "_3v-2";